import type { AppUser } from '../types';
import type { Role } from '../core/constants/roles';
import { DEMO_ACCOUNTS } from './demoCredentials';

export const DEMO_USERS: Record<Role, AppUser> = Object.fromEntries(
  DEMO_ACCOUNTS.map((a) => [
    a.role,
    {
      id: `${a.role}_1`,
      name: a.name,
      role: a.role,
      houseId: a.houseId,
      houseIds: a.houseIds ?? (a.houseId ? [a.houseId] : []),
      email: a.email,
    },
  ]),
) as Record<Role, AppUser>;

export function getDemoUser(role: Role | string): AppUser | null {
  return DEMO_USERS[role as Role] ?? null;
}
